import { TFunction } from 'i18next';
import { BreadCrumb, Tab } from '~src/modules/reports/interfaces/header.interface';
import { routes } from '~src/routingConfig';

export const getBreadCrumbLinks: (t: TFunction, name: string) => BreadCrumb[] = (
  t: TFunction,
  name: string,
) => [
  {
    name: t('x.sidebar.settings.performance_management'),
    link: routes.contentScales.performanceManagement,
  },
  {
    name: name,
    link: routes.contentScales.performanceManagement,
  },
];

export const getTabs: (id: string) => Tab[] = (id) => [
  {
    translationKey: 'x.admin.feedback.cycles.tab.settings',
    name: 'Settings',
    link: `${routes.contentScales.adminFeedbackCycle(id)}/settings`,
  },
  {
    translationKey: 'x.admin.feedback.cycles.tab.completion',
    name: 'Completion',
    link: `${routes.contentScales.adminFeedbackCycle(id)}/completion`,
  },
];
